import { toast } from "sonner"

export const showDefaultToast = (message: string) => {
  toast(message)
}

export const showSuccessToast = (message: string) => {
  toast.success(message)
}

export const showErrorToast = (message: string) => {
  toast.error(message)
}

export const showInfoToast = (message: string) => {
  toast.info(message)
}

export const showWarningToast = (message: string) => {
  toast.warning(message)
}

export { toast }
